import { FileSearchOutlined } from "@ant-design/icons";
import { Button, Row, Table, Typography, message, Card } from "antd";
import { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import HTTPClient from "../../utils/HTTPClient";

export default function ListaApp({}) {
    const navigate = useNavigate();
    const [projects, setProjects] = useState(null); // temp
    const [currentDatetime, setCurrentDatetime] = useState(null);
    const [currentDatetimeUpdates, setCurrentDatetimeUpdates] = useState(0);
    const [searchParams, setSearchParams] = useSearchParams();
    const { t } = useTranslation();

    useEffect(() => {
        HTTPClient.get("/app/").then((res) => {
            setCurrentDatetime(new Date());
            let tempProjects = res.data.sort((a, b) =>
                a.creation_date < b.creation_date ? 1 : -1
            );
            for (let i = 0; i < tempProjects.length; i++) {
                tempProjects[i].creation_date = new Date(tempProjects[i].creation_date + "Z");
            }
            setProjects(tempProjects);
            // for 30 seconds, update the current datetime every 5 seconds
            // loading spinner for apps
            const interval = setInterval(() => {
                setCurrentDatetime(new Date());
                setCurrentDatetimeUpdates((prevCount) => {
                    if (prevCount > 10) {
                        clearInterval(interval);
                        return prevCount;
                    }
                    return prevCount + 1;
                });
            }, 7000);
            return () => clearInterval(interval);
        });
    }, []);

    useEffect(() => {
        const checkForPayment = async () => {
            const success = searchParams.get("success");
            if (success) {
                message.success(t("lista_app.success"));
            }
            setSearchParams("");
        };
        checkForPayment();
    }, []);

    const isLargeScreen = useMediaQuery({
        query: "(min-width: 771px)",
    });

    const dataColumns = [
        {
            title: t("lista_app.fields.name"),
            dataIndex: "name",
            key: "name",
        },
        {
            title: t("lista_app.fields.technology"),
            dataIndex: "technology",
            key: "technology",
            render: (_, record) => (
                <Typography.Text>
                    {record?.technology
                        ?.toLowerCase()
                        .split("_")
                        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                        .join(" ")}
                </Typography.Text>
            ),
        },
        {
            title: "Status",
            dataIndex: "active",
            key: "active",
            render: (_, record) =>
                ({
                    true: (
                        <Typography.Text style={{ color: "green" }}>
                            {t("lista_app.active")}
                        </Typography.Text>
                    ),
                    false: (
                        <Typography.Text style={{ color: "red" }}>
                            {t("lista_app.not_active")}
                        </Typography.Text>
                    ),
                }[record?.active]),
        },
        {
            title: t("lista_app.fields.details"),
            dataIndex: "dettagli",
            key: "dettagli",
            render: (_, record) => (
                <Typography.Text>
                    <Button
                        type="primary"
                        onClick={() => navigate(record.name)}
                        loading={(currentDatetime - record?.creation_date) / 1000 < 30}>
                        {(currentDatetime - record?.creation_date) / 1000 >= 30 ? (
                            <FileSearchOutlined />
                        ) : null}
                    </Button>
                </Typography.Text>
            ),
        },
    ];

    const createPortalSession = async () => {
        try {
            await HTTPClient.post("/stripe/create_portal_session");
        } catch (e) {
            if (e.response.status === 303) {
                window.location.replace(e.response.data);
                return;
            }
            message.error(t("lista_app.create_session_error"));
        }
    };
    return (
        <Row style={{ padding: isLargeScreen ? "20px 50px" : "10px 10px" }}>
            <Row>
                <Typography.Text style={{ fontSize: "36px", fontWeight: "bold" }}>
                    {t("lista_app.title")}
                </Typography.Text>
            </Row>
            <Row style={{ width: "100%", marginTop: "10px" }}>
                <Typography.Text>
                    {t("lista_app.subtitle")}
                    <br />
                </Typography.Text>
            </Row>
            {projects?.filter((e) => e.resource_id !== "free").length > 0 ? (
                <Row style={{ width: "100%", marginTop: "10px" }}>
                    <Button type="primary" onClick={() => createPortalSession()}>
                        {t("lista_app.manage_subscriptions")}
                    </Button>
                </Row>
            ) : null}
            <Row style={{ width: "100%" }}>
                {projects?.length ? (
                    <Table
                        columns={dataColumns}
                        dataSource={projects}
                        pagination={false}
                        style={{ marginTop: "25px", width: "100%" }}
                    />
                ) : (
                    <Card style={{ width: "100%", marginTop: "25px" }}>
                        <Typography.Text> {t("lista_app.empty")}</Typography.Text>
                        <div>
                            <Button
                                type="primary"
                                style={{ marginTop: "10px" }}
                                onClick={() => navigate("/pro/app")}>
                                {t("lista_app.go_to_store")}
                            </Button>
                        </div>
                    </Card>
                )}
            </Row>
        </Row>
    );
}
